export enum HostSystem {
  UBS = 'UBS',
  WBS = 'WBS',
  ALB = 'ALB',
  UCS = 'UCS',
  TFF = 'TFF',
  CAN1 = 'CAN1',
  CAN2 = 'CAN2',
  MIRAKL = 'MIRAKL',
}
